import React, { Component, forwardRef } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../utils/withRouter";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Tab, Nav } from "react-bootstrap";
import Loader from "../../utils/Loader";
import { Modal, Button } from "react-bootstrap";
import Header from "../../common_components/Header";
import {
  insert_update_guideline_action,
  get_guideline_file_action,
} from "../../actions/accounts_action/guideline_action";
import {
  clearSessionStorage,
  toastError,
  toastSuccess,
  BASE_URL,
} from "../../utils/constants";

class guidelines extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isOpen: false,
      fileName: "",
      filePath: "",
      fileType: "",
      fileName2: "",
      filePath2: "",
      fileType2: "",
      GuidelineID: "",
      existFilePath: "",
      existFilePath2: "",
      ViewDocument: "",
      ViewDocument2: "",
    };
  }
  async componentDidMount() {
    this.getGuidelineFile();
  }

  getGuidelineFile() {
    const { fileName, filePath, fileType } = this.state;
    this.setState({ isLoading: true });
    this.props
      .get_guideline_file_action()
      .then((data) => {
        if (data.error != 1) {
          if (data.data != "") {
            const url = BASE_URL.split("/api");
            const file = data.data[0]["GuideLine"]
              ? data.data[0]["GuideLine"].split("/document/guideline/")
              : null;
            const file2 = data.data[0]["VendorGuideline"]
              ? data.data[0]["VendorGuideline"].split("/document/guideline/")
              : null;
            console.log(
              "ducument--------------",
              url[0] + data.data[0]["GuideLine"]
            );
            if (file != null) {
              this.setState({
                fileName: file[1],
                GuidelineID: data.data[0]["GuidelineID"],
                existFilePath: data.data[0]["GuideLine"],
                ViewDocument: url[0] + data.data[0]["GuideLine"],
              });
            }
            if (file2 != null) {
              this.setState({
                fileName2: file2[1],
                GuidelineID: data.data[0]["GuidelineID"],
                existFilePath2: data.data[0]["VendorGuideline"],
                ViewDocument2: url[0] + data.data[0]["VendorGuideline"],
              });
            }
          }
          this.setState({ isLoading: false });
        } else {
          this.setState({ isLoading: false });
          toast.error(data.msg, {
            position: "top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  insertUpdateGuidelineFile() {
    const {
      fileName,
      filePath,
      fileType,
      GuidelineID,
      existFilePath,
      existFilePath2,
      fileName2,
      filePath2,
      fileType2,
    } = this.state;
    this.props
      .insert_update_guideline_action(
        GuidelineID,
        fileName,
        filePath,
        fileType,
        existFilePath,
        fileName2,
        filePath2,
        fileType2,
        existFilePath2
      )
      .then((data) => {
        if (data.error != 1) {
          toastSuccess("guideline updated successfully");
          this.getGuidelineFile();
          this.setState({ isLoading: false });
        } else {
          this.setState({ isLoading: false });
          toast.error(data.msg, {
            position: "top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  onFilePick = async (e, file, num) => {
    e.preventDefault();
    const {
      formFile,
      trcFile,
      declarationFile,
      formFileType,
      declarationFileType,
      trcFileType,
    } = this.state;
    console.log("file--", file);
    var image = "";
    if (file[0]["size"] > 20971520) {
      toast.error("File size more than 5MB are not allow.", {
        position: "top-center",
        theme: "colored",
        autoClose: 3000,
        hideProgressBar: true,
      });
    } else {
      if (file[0]["name"].toString().toLowerCase().includes(".html")) {
        image = await this.onHTMLFileSelect(file[0]);
        if (num == 1) {
          this.setState({ filePath: image, fileName: file[0]["name"] });
          const fileType = file[0]["type"];
          var fileTypeList;
          if (fileType.includes("/")) {
            fileTypeList = fileType.split("/");
          }
          this.setState({
            fileType: fileTypeList.length > 0 ? fileTypeList[1] : "",
          });
        } else {
          this.setState({ filePath2: image, fileName2: file[0]["name"] });
          const fileType2 = file[0]["type"];
          var fileTypeList2;
          if (fileType2.includes("/")) {
            fileTypeList2 = fileType2.split("/");
          }
          this.setState({
            fileType2: fileTypeList2.length > 0 ? fileTypeList2[1] : "",
          });
        }
      } else {
        toast.error("Only .html are allowed", {
          position: "top-center",
          theme: "colored",
          autoClose: 3000,
          hideProgressBar: true,
        });
      }
    }
  };

  onHTMLFileSelect = (file) =>
    new Promise((resolve) => {
      let base64;
      // FileReader function for read the file.
      let fileReader = new FileReader();
      // Onload of file read the file content
      fileReader.onload = function (fileLoadedEvent) {
        base64 = fileLoadedEvent.target.result;
        // Print data in console
        resolve(base64);
      };
      // Convert data to base64
      fileReader.readAsDataURL(file);
    });

  removeFile(num) {
    if (num == 1) {
      this.setState({
        fileName: "",
        filePath: "",
        fileType: "",
      });
    } else {
      this.setState({
        fileName2: "",
        filePath2: "",
        fileType2: "",
      });
    }
  }

  render() {
    const {
      isOpen,
      isLoading,
      fileName,
      ViewDocument,
      fileName2,
      ViewDocument2,
    } = this.state;
    const roleId = sessionStorage.getItem("roleId");

    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <Header data={[13]} />
          <main id="main">
            <Header data={[15]} />
            <section style={{ marginTop: 115 }}>
              <div className="container-fluid">
                <div className="page-header">
                  <h4 className="page-title"> Guidelines & Info</h4>
                </div>
                <div className="card Service_fields">
                  <div className="card-body">
                    <Tab.Container defaultActiveKey={roleId == 13 ? "vGuide" : "guideline"}>
                      <Nav
                        variant="tabs"
                        className="nav nav-tabs nav-tabs-custom nav-success mb-3"
                        role="tablist"
                      >
                        {roleId == 13 ? <></> : (
                          <Nav.Item>
                            <Nav.Link eventKey="guideline">Guidelines</Nav.Link>
                          </Nav.Item>
                        )}
                        <Nav.Item>
                          <Nav.Link eventKey="vGuide">
                            Vendor guidelines
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                      <Tab.Content>
                        {roleId == 13 ? <></> : (
                          <Tab.Pane eventKey="guideline">
                            {roleId == 2 || roleId == 1 ? (
                              <>
                                <div className="row">
                                  <div className="form-group col-md-6">
                                    <div className="upload__box">
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        * kindly convert the pdf file to html file
                                        using online converter
                                      </span>
                                      <div
                                        className="upload__btn-box"
                                        style={{ width: "400px" }}
                                      >
                                        {fileName != "" ? (
                                          <div className="membership_file">
                                            <span className="overflow-membership">
                                              {fileName}
                                            </span>
                                            <span
                                              className="membership_file_cross text-danger"
                                              onClick={() => this.removeFile(1)}
                                            >
                                              X
                                            </span>
                                          </div>
                                        ) : (
                                          <label className="upload__btn">
                                            <p>
                                              Upload Guidelines{" "}
                                              <span className="upload_size">
                                                ( .html files only, Max 5MB each )
                                              </span>
                                            </p>
                                            <input
                                              type="file"
                                              data-max-size="5MB"
                                              className="upload__inputfile"
                                              onChange={(e) =>
                                                this.onFilePick(
                                                  e,
                                                  e.target.files,
                                                  1
                                                )
                                              }
                                              accept=".html"
                                              multiple
                                            />
                                          </label>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="mx-2">
                                    <button
                                      className="btn save_btn"
                                      onClick={() => {
                                        this.insertUpdateGuidelineFile();
                                      }}
                                      disabled={fileName == ""}
                                    >
                                      Update
                                    </button>
                                  </div>
                                  <div className="mx-2">
                                    <a
                                      href="javascript:void(0);"
                                      onClick={() =>
                                        this.props.navigate("/normalView")
                                      }
                                      className="btn back_btn"
                                    >
                                      Back
                                    </a>
                                  </div>
                                </div>
                                <hr />
                              </>
                            ) : (
                              <></>
                            )}
                            <div
                              class="modal-body p-0 pb-1"
                              style={
                                {
                                  // scale: '1.2'
                                }
                              }
                            >
                              <iframe
                                id="myIframe"
                                src={ViewDocument}
                                width="100%"
                                height="500px"
                                title="Bing"
                                style={{
                                  // scale: '1.1'
                                  margin: "auto",
                                }}
                              ></iframe>
                            </div>
                          </Tab.Pane>
                        )}
                        <Tab.Pane eventKey="vGuide">
                          {roleId == 2 || roleId == 1 ? (
                            <>
                              <div className="row">
                                <div className="form-group col-md-6">
                                  <div className="upload__box">
                                    <span className="text-danger text-start text-left d-block mt-1">
                                      * kindly convert the pdf file to html file
                                      using online converter
                                    </span>
                                    <div
                                      className="upload__btn-box"
                                      style={{ width: "400px" }}
                                    >
                                      {fileName2 != "" ? (
                                        <div className="membership_file">
                                          <span className="overflow-membership">
                                            {fileName2}
                                          </span>
                                          <span
                                            className="membership_file_cross text-danger"
                                            onClick={() => this.removeFile(2)}
                                          >
                                            X
                                          </span>
                                        </div>
                                      ) : (
                                        <label className="upload__btn">
                                          <p>
                                            Upload Vendor Guidelines{" "}
                                            <span className="upload_size">
                                              ( .html files only, Max 5MB each )
                                            </span>
                                          </p>
                                          <input
                                            type="file"
                                            data-max-size="5MB"
                                            className="upload__inputfile"
                                            onChange={(e) =>
                                              this.onFilePick(
                                                e,
                                                e.target.files,
                                                2
                                              )
                                            }
                                            accept=".html"
                                            multiple
                                          />
                                        </label>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="mx-2">
                                  <button
                                    className="btn save_btn"
                                    onClick={() => {
                                      this.insertUpdateGuidelineFile();
                                    }}
                                    disabled={fileName2 == ""}
                                  >
                                    Update
                                  </button>
                                </div>
                                <div className="mx-2">
                                  <a
                                    href="javascript:void(0);"
                                    onClick={() =>
                                      this.props.navigate("/normalView")
                                    }
                                    className="btn back_btn"
                                  >
                                    Back
                                  </a>
                                </div>
                              </div>
                              <hr />
                            </>
                          ) : (
                            <></>
                          )}
                          <div
                            class="modal-body p-0 pb-1"
                            style={
                              {
                                // scale: '1.2'
                              }
                            }
                          >
                            <iframe
                              id="myIframe"
                              src={ViewDocument2}
                              width="100%"
                              height="500px"
                              title="Bing"
                              style={{
                                // scale: '1.1'
                                margin: "auto",
                              }}
                            ></iframe>
                          </div>
                        </Tab.Pane>
                      </Tab.Content>
                    </Tab.Container>
                    {roleId == 3 ? (
                      <div>
                        <button
                          // style={{ scale: "0.85" }}
                          onClick={() => this.props.navigate("/normalView")}
                          class="btn btn-secondary ml-2"
                        >
                          Back
                        </button>
                      </div>
                    ) : roleId == 13 ? (
                      <div>
                        <button
                          // style={{ scale: "0.85" }}
                          onClick={() => this.props.navigate("/thirdPartyOrderList")}
                          class="btn btn-secondary ml-2"
                        >
                          Back
                        </button>
                      </div>
                    ) : <></>}
                  </div>
                </div>
              </div>
            </section>
          </main>
          <ToastContainer />
        </>
      </>
    );
  }
}
export default withRouter(
  connect(null, { insert_update_guideline_action, get_guideline_file_action })(
    guidelines
  )
);
